<template>

    <div class="search-contents-wrap _value-select">

        <button type="button" class="mobile-back-btn" v-on:click="mobileSearchBack">
            <div class="md_icon-btn _small">
                <div class="inner"><SvgIconBack /></div>
            </div>
            <p>BACK</p>
        </button>

        <div class="scroll-inner">
            <div class="item-wrap search-contents-inner _kakakujiku">
                <div class="item form_radio _kakakujiku" v-for="(price_zone,index) in $store.state.search.set.price_zone" v-bind:key="index">
                    <input type="radio" name="value-select" :id="'value-select' + index" v-on:change="changePriceZone(price_zone)">
                    <label v-if="price_zone.id == 1" :for="'value-select' + index"><span class="_svg-coin">{{ price_zone.name }} <SvgCoinGray /><SvgCoinGray /><SvgCoinGray /><SvgCoinBlack /><SvgCoinBlack /></span></label>
                    <label v-if="price_zone.id == 2" :for="'value-select' + index"><span class="_svg-coin">{{ price_zone.name }} <SvgCoinGray /><SvgCoinGray /><SvgCoinGray /><SvgCoinGray /><SvgCoinBlack /></span></label>
                    <label v-if="price_zone.id == 3" :for="'value-select' + index"><span class="_svg-coin">{{ price_zone.name }} <SvgCoinGray /><SvgCoinGray /><SvgCoinGray /><SvgCoinGray /><SvgCoinGray /></span></label>
                </div>
            </div>
        </div>
    </div>

</template>

<style>
._svg-coin {
    display: flex;
}
._svg-coin svg {
    width: 20px;
}
</style>

<script>
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgCoinGray from '@/components/EndUser/svg/SvgCoinGray'
    import SvgCoinBlack from '@/components/EndUser/svg/SvgCoinBlack'

    export default {
        components: {
            SvgIconBack,
            SvgCoinGray,
            SvgCoinBlack,
        },
        methods: {
            ////////////////////////////////////
            //検索メニューMobile表示Backボタン
            ////////////////////////////////////
            mobileSearchBack: function () {
                this.tabSelectorActive = '';
                for (const element of document.getElementsByName('search-select')) {
                    element.checked = false;
                }
            },
            changePriceZone(price_zone) {
                this.$store.state.search.form.price_zone = price_zone;
            }
        }
    }
</script>